import CartConflictToast from "./Components/Cart/CartConflictToast.js";
import React, { lazy, Suspense, useEffect } from "react"
import "./App.css"
import 'bootstrap/dist/css/bootstrap.min.css'
import { Helmet } from "react-helmet";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { FriendlyUrlComponent } from "./Components"
import { Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from "./Utils/ProtectedRoute"
import Logout from "./Utils/Logout";
import { addWishlist, clearWishlist, fetchProducts } from "./redux/Slices/cartSlice";
import { useDispatch } from "react-redux";
import Blog from "./Components/Footer/Blogs";
import axiosConfig from "./Service/axiosConfig"
import { checkSession } from "./Utils/checkSession";
import useCartSync from "./Utils/useCartSync";
const Home = lazy(() => import("./Pages/Home"))
const ProductSearch = lazy(() => import("./Pages/ProductSearch"))
const Brands = lazy(() => import("./Pages/Brands"))
const NotFound = lazy(() => import("./Pages/NotFound"))
const Dashboard = lazy(() => import("./Pages/Dashboard"))
const SearchProducts = lazy(() => import("./Pages/SearchProducts"))
const CategoriesPage = lazy(() => import("./Pages/CategoriesPage"))
const Checkout = lazy(() => import("./Pages/Checkout"))
const MyAddress = lazy(() => import("./Pages/MyAddress"))
const MyProfile = lazy(() => import("./Pages/MyProfile"))
const Wishlistpage = lazy(() => import("./Pages/Wishlistpage"))
const SubCategoriesPage = lazy(() => import("./Pages/SubCategoriesPage"))
const MyOrders = lazy(() => import("./Pages/MyOrders"))
const MyOrderDetails = lazy(() => import("./Pages/MyOrderDetails"))
const PrivacyPage = lazy(() => import("./Components/PrivacyPages/PrivacyPage"))
const TermsAndConditions = lazy(() => import("./Components/PrivacyPages/TermsAndCondations"))
const AboutUs = lazy(() => import("./Components/PrivacyPages/AboutUs"))
const ContuctUs = lazy(() => import("./Components/PrivacyPages/ContuctUs"))
const Faq = lazy(() => import("./Components/PrivacyPages/Faq"))
const Cancellation = lazy(() => import("./Components/PrivacyPages/Cancellation"))
const ReturnPolicy = lazy(() => import("./Components/PrivacyPages/ReturnPolicy"))
const AccountResp = lazy(() => import("./Components/Navbar/AccountResp"))
const Wallet = lazy(() => import("./Pages/Wallet"))

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  // Enable real-time cross-device and multi-tab cart sync
  useCartSync();
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-W15NVYHE61', {
        page_path: location.pathname,
      });
    }
  }, [location]); // ✅ add this
  useEffect(() => {
    const init = async () => {
      if (!localStorage.getItem("token")) {
        return;
      }

      const isValid = await checkSession();

      if (!isValid) {
        dispatch(clearWishlist());
      }
    };

    init();
  }, [dispatch]);
  useEffect(() => {
    // Find all style tags
    const styles = document.querySelectorAll('style');
    const body = document.querySelector('body');

    // Move all style tags to the bottom of the body
    styles.forEach((style) => {
      body.appendChild(style); // or append to the head as last child
    });
  }, []);
  // useEffect(() => {
  //   const userId = localStorage.getItem("userId");
  //   if (userId) {
  //     axiosConfig
  //       .get(`/catlog/wishlists/?user=${userId}`)
  //       .then((res) => {
  //         res.data.results.forEach((item) => {
  //           dispatch(
  //             addWishlist({
  //               productId: item.product.id,
  //               wish_id: item.id,
  //             })
  //           );
  //         });
  //       });
  //   }
  // }, []);
  // useEffect(() => {
  //   const userId = localStorage.getItem("userId");

  //   if (userId) {
  //     dispatch(clearWishlist()); // ✅ VERY IMPORTANT

  //     axiosConfig
  //       .get(`/catlog/wishlists/?user=${userId}`)
  //       .then((res) => {
  //         res.data.results.forEach((item) => {
  //           dispatch(
  //             addWishlist({
  //               productId: item.product.id,
  //               wish_id: item.id,
  //             })
  //           );
  //         });
  //       });
  //   }
  // }, [dispatch]);
  // useEffect(() => {
  //   const userId = localStorage.getItem("userId");

  //   if (userId) {
  //     dispatch(clearWishlist());

  //     axiosConfig.get(`/catlog/wishlists/?user=${userId}`)
  //       .then(res => {
  //         res.data.results.forEach(item => {
  //           dispatch(addWishlist({
  //             productId: item.product.id,
  //             wish_id: item.id,
  //           }));
  //         });
  //       });
  //   }
  // }, [dispatch]);
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;

    dispatch(clearWishlist());

    axiosConfig.get(`/catlog/wishlists/?user=${userId}`)
      .then(res => {
        res.data.results.forEach(item => {
          dispatch(addWishlist({
            productId: item?.product.id,
            wish_id: item?.id,
          }));
        });
      });
  }, [dispatch]);

  return (

    <div className="app-container">
      <CartConflictToast />
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/logout" element={<Logout />} />
          <Route path='/product-search' element={<ProductSearch />} />
          <Route path='/s' element={<SearchProducts />} />
          <Route path='/c/:categoryslug' element={<CategoriesPage />} />
          <Route path='/c/:categoryslug/:subcategoryslug' element={<SubCategoriesPage />} />

          <Route element={<ProtectedRoute />} >
            <Route path='/account' element={<AccountResp />} />
            <Route path='/account/profile' element={<MyProfile />} />
            <Route path='/account/orders' element={<MyOrders />} />
            <Route path='/account/orders/:orderId/:address' element={<MyOrderDetails />} />
            <Route path='/account/orders/:orderId' element={<MyOrderDetails />} />
            <Route path='/account/addresses' element={<MyAddress />} />
            <Route path='/account/wallet' element={<Wallet />} />
            <Route path='/checkout' element={<Checkout />} />
          </Route>


          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms-services" element={<TermsAndConditions />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/cancellation" element={<Cancellation />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contactus" element={<ContuctUs />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/wishlist" element={<Wishlistpage />} />
          <Route path='/wishlist/:friendlyurl' element={<FriendlyUrlComponent />} />
          <Route path='/:friendlyurl/' element={<FriendlyUrlComponent />} />
          <Route path='/:categoryurl/:friendlyurl/' element={<FriendlyUrlComponent />} />
          <Route path='/:subcategoryurl/:categoryurl/:friendlyurl/' element={<FriendlyUrlComponent />} />
          <Route path='*' element={<NotFound />} />
          <Route path='/not-found' element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}
export default App;
